import {
  ConfirmEvent,
  ConfirmState,
  defaultConfirmState,
} from "./ConfirmContext";

export function confirmReducer(state: ConfirmState, event: ConfirmEvent) {
  switch (event.type) {
    case "show":
      state = {
        show: true,
        title: event.title,
        description: event.description,
        cancelBtnText: event.cancelBtnText,
        confirmBtnText: event.confirmBtnText,
      };
      break;
    case "hide":
      state = defaultConfirmState;
      break;
  }
  return state;
}
